import React, { useEffect, useState, useMemo } from "react"
import { Tab, Tabs } from "react-bootstrap"
import PageBuilder from "../../../pages/PageBuilder"
import { useLocation, useNavigate } from "react-router-dom"
import { TModuleTabs } from "./_types"
import { useModalContext } from "../helpers/ModalContext"

const ModuleTabs = React.memo<TModuleTabs>(props => {
    const { settings } = props


    const resolvedTabs = useMemo(() => {
        if (settings) {
            if (Array.isArray(settings)) {
                return settings.filter(tab => tab.settings?.is_visible !== false).map(tab => ({ ...tab, key: tab.title }))
            } else {
                return Object.entries(settings).map(([article, tab]) => ({ ...tab, key: article }))
            }
        } else {
            return []
        }
    }, [settings])


    const navigate = useNavigate()
    const location = useLocation()
    const modalContext = useModalContext()
    const isTabsInsideModal = Boolean(modalContext.insideModal)
    
    const initialKey = useMemo(() => {
        const initialQueryStringKey = location.search.match(/\?tab=\w+/gi)?.[0].replace(/\?tab=/, "")
        const isValidInitialKey = initialQueryStringKey ? resolvedTabs.some(tab => tab.key === initialQueryStringKey) : false
        if (!isTabsInsideModal && isValidInitialKey) {
            return initialQueryStringKey as string
        } else {
            return resolvedTabs.length ? resolvedTabs[0].key : null
        }

    }, [resolvedTabs])

    const [key, setKey] = useState<string | null>(initialKey)


    useEffect(() => {
        /* Проверка на модальное окно стоит для случаев, когда модалку не нужно закрывать, но саму страницу внутри нужно перезагрузить */
        if (resolvedTabs.length && key !== initialKey && !isTabsInsideModal) {
            setKey(initialKey)
        }
    }, [resolvedTabs])

    return <div>
        <Tabs
            id="moduleTabs"
            activeKey={key as string | undefined}
            onSelect={key => {
                const keyIndex = resolvedTabs.findIndex(tab => tab.key === key)
                let queryString
                if (keyIndex === 0) {
                    queryString = isTabsInsideModal && location.search ? location.pathname + location.search.replace(/&tab=.*/, "") : location.pathname
                } else {
                    queryString = isTabsInsideModal && location.search ? location.search.replace(/&tab=.*/, "") + `&tab=${key}` : `?tab=${key}`
                }
                navigate(queryString)
                setKey(key)
            }}
            className="mb-3"
            mountOnEnter
            unmountOnExit
        >
            {resolvedTabs.map(tab => <Tab
                key={tab.key}
                eventKey={tab.key}
                title={<div className="moduleTabs_tabTitle">{tab.title}{tab.settings?.counter ? <span className="moduleTabs_tabCounter badge badge-primary">{tab.settings?.counter}</span> : null}</div>}>
                <PageBuilder data={tab.body} isFetching={false} showProgressBar={false} />
            </Tab>)}
        </Tabs>
    </div>
})

export default ModuleTabs